<template>
    <div class="dispensing-item-preview">
        <v-form
            ref="form"
            v-model="form"
            :disabled="readOnlyRules || !dispensingPermitted"
            class="dispensing-permitted-form"
        >
            <v-col cols="12" lg="9" class="p-0">
                <div class="action with-toggler">
                    <span
                        >{{ $root.defaultMandatoryAsteriks }}
                        {{ t('patients::dispensing.form.label.dispensing_permitted') }}</span
                    >
                    <div class="toggler">
                        <b-switch
                            to-mutate="patients::dispensingForm.dispensing_permitted"
                            reverse
                            mandatory
                        ></b-switch>
                    </div>
                </div>
            </v-col>
            <v-col cols="12" lg="9" class="p-0 pt-4">
                <b-date-picker-store
                    mandatory
                    to-mutate="patients::dispensingForm.blood_result_date"
                    :label="t('patients::dispensing.form.label.blood_result_date')"
                    :rules="validationRules.blood_result_date"
                ></b-date-picker-store>
            </v-col>
            <b-textarea
                rows="2"
                to-mutate="patients::dispensingForm.reason"
                :label="t('patients::dispensing.form.label.reason')"
                :rules="validationRules.reason"
                mandatory
            ></b-textarea>
            <v-btn color="primary" small rounded outlined :disabled="!canSaveForm" @click="startDispensing">{{
                t('patients::button.save')
            }}</v-btn>
        </v-form>
    </div>
</template>

<script>
export default {
    props: {
        readOnlyRules: {
            type: Boolean,
            required: true,
            default: false,
        },
    },
    data() {
        return {
            form: false,
            validationRules: {
                blood_result_date: [(v) => !!v || t('users::validation.field.required')],
                reason: [(v) => !!v || t('users::validation.field.required')],
            },
        };
    },
    computed: {
        dispensingForm() {
            return this.$store.state.patients.dispensingForm;
        },
        patientId() {
            return this.$store.state.patients.patient.id;
        },
        canSaveForm() {
            return this.form && this.dispensingForm.dispensing_permitted;
        },
        isHcpDispensers() {
            return (
                this.$store.state.user.profile &&
                (this.$store.state.user.profile.role === 'hcp-pharmacy-dispensers' ||
                    this.$store.state.user.profile.role === 'hcp-analyser-dispenser')
            );
        },
        dispensingPermitted() {
            return (
                !this.isHcpDispensers ||
                (this.isHcpDispensers && this.$store.state.patients.patient?.is_allowed_to_dispense)
            );
        },
    },
    created() {},
    mounted() {},
    methods: {
        startDispensing() {
            this.$store.dispatch('patients/setDispensingLoading', true);
            return axios
                .post(
                    route('api.v1.patients.dispensing-stages.start', {
                        patient: this.patientId,
                    }),
                    {
                        blood_result_date: this.dispensingForm.blood_result_date,
                        reason: this.dispensingForm.reason,
                        from_ui: true,
                    }
                )
                .then(() => {
                    this.$store.dispatch('patients/resetDispensingForm');
                })
                .catch((error) => {
                    this.$store.dispatch('patients/setDispensingLoading', false);
                    if (error.response && error.response.status === 422) {
                        this.$store.dispatch('patients/setErrorMessages', {
                            isDispensingForm: true,
                            errors: error.response.data.errors,
                        });
                    } else {
                        this.$root.notify('error', error.response.data.error);
                    }
                })
                .finally(() => {
                    // this.$store.dispatch('patients/setDispensingLoading', false);
                });
        },
    },
};
</script>
